import { forwardRef } from 'react';
import cn from 'bem-cn';

import { ButtonProps } from './Button.types';

import './Button.scss';

const b = cn('button');

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    (
        { children, variant = 'primary', size = 'medium', className, fullWidth = false, type = 'button', ...props },
        ref,
    ) => {
        const buttonClassName = b(
            {
                variant,
                size,
                'full-width': fullWidth,
            },
            [],
        ).mix(className);

        return (
            <button ref={ref} type={type} className={buttonClassName} {...props}>
                {children}
            </button>
        );
    },
);

Button.displayName = 'Button';
